<div class="crud-item-page">
  <form [formGroup]="form">
    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Username" [matTooltipDisabled]="disabledTooltip(this.username)">
          <mat-label i18n="@@type.User.username">Username</mat-label>
          <input matInput formControlName="username" id="username" (ngModelChange)="usernameChanging($event)"
            [(ngModel)]="item.username" (ngModelChange)="usernameChanged($event)" #id placeholder="Username">
        </mat-form-field>
      </span>

      <span>
        <mat-slide-toggle floatLabel="always" appearance="none" color="primary" formControlName="enabled" id="enabled"
          (ngModelChange)="enabledChanging($event)" [(ngModel)]="item.enabled" (ngModelChange)="enabledChanged($event)"
          #enabled i18n="@@type.User.enabled">
          Enabled </mat-slide-toggle>
      </span>

      <span>
        <mat-slide-toggle floatLabel="always" appearance="none" color="primary" formControlName="systemProvided"
          id="systemProvided" (ngModelChange)="systemProvidedChanging($event)" [(ngModel)]="item.systemProvided"
          (ngModelChange)="systemProvidedChanged($event)" #enabled i18n="@@type.User.systemProvided">
          System Provided </mat-slide-toggle>
      </span>

      <span>
        <mat-slide-toggle floatLabel="always" appearance="none" color="primary" formControlName="passwordLoginEnabled"
          id="passwordLoginEnabled"  [(ngModel)]="item.passwordLoginEnabled"
           #enabled i18n="@@type.User.passwordLoginEnabled"> Local Password Login Enabled </mat-slide-toggle>
      </span>

    </div>
    <mat-divider></mat-divider>


    <div class="crud-item-section">
      <div class="chip-field">
        <mat-chip-list #rolesChips>
          <mat-chip *ngFor="let role of item.roles" [selectable]="!readOnly" [removable]="!readOnly"
            (removed)="removeRole(role)" color="primary" [matTooltip]="role.description">
            {{role.name}}
            <mat-icon matChipRemove *ngIf="!readOnly">cancel</mat-icon>
          </mat-chip>
        </mat-chip-list>
        <mat-form-field matTooltip="Select a Role from the list" [matTooltipDisabled]="disabledTooltip(this.roles)"
          class="crud-item-input-wide">
          <mat-label i18n="@@type.User.roles">Roles</mat-label>
          <input matInput [matAutocomplete]="rolesAutocomplete" [matChipInputFor]="rolesChips" formControlName="roles"
            id="roles" #roles placeholder="Roles">
          <mat-autocomplete id="rolesAutocomplete" #rolesAutocomplete [displayWith]="rolesDisplay"
            (optionSelected)="selectedRole($event)">
            <mat-option *ngFor="let role of rolesSelectionList | async" [value]="role">
              {{rolesDisplay(role)}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

    </div>
    <mat-divider></mat-divider>

  </form>
</div>
